import * as L from 'leaflet';
import * as marked from 'marked';

class FreeridePolys {
  map;
  featureGroup;
  constructor(map, featureGroup) {
    this.map = map;
    this.featureGroup = featureGroup;
  }

  loadPolys() {
    fetch("/sh/freeride/polys")
      .then((d) => d.json())
      .then((d) => {
        for (let i = 0; i < d.length; i++) {
          const coords = [];
          for (var j = 0; j < d[i].geometry.coordinates[0].length; j++) {
            coords.push([
              d[i].geometry.coordinates[0][j][1],
              d[i].geometry.coordinates[0][j][0]
            ]);
          }
          var color = 'darkblue';
          if (d[i].properties.type === 'waldwild') {
            color = 'green';
          }
          var l = L.polygon(coords, {
            color: color
          });
          l.properties = d[i].properties;
          l._id = d[i]._id;
          // console.log('xxPOLY: ', l.properties.name,  l.properties.description);
          if (l.properties.name && l.properties.description) {
            const pop = new L.Popup({
              minWidth: 500,
              className: 'markedPopup'
            });
            pop.setContent(
              '<h4>' + l.properties.name + '</h4>' +
              '<p>' + marked(l.properties.description) + '</p>');
            l.bindPopup(pop);
          }
          this.featureGroup.addLayer(l);
        }
      })
  }

}

const FreeridePolyLayer = L.FeatureGroup.extend({
  onAdd: function (map) {
    const polys = new FreeridePolys(map, this);
    polys.loadPolys();
  },
});

export { FreeridePolys, FreeridePolyLayer }
